import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Customer } from './customer';
import { IdentityService } from '../../../core/services/identity.service';
import { CrudService } from '../../../shared/crud.service';
import { ApiRoutes } from '../../../shared/api-routes';

@Injectable()
export class CustomersService extends CrudService<Customer> {

  constructor(apiRoutes: ApiRoutes, http: HttpClient, identityService: IdentityService) {
    super(apiRoutes.customers, http, identityService);
  }
}
